import * as React from 'react';
import { AlertTriangle } from 'react-feather';
import styled from 'styled-components';
import { space } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import { theme } from '../../theme';
import { StyledSystemProps } from '../../theme/StyledSystemProps';
import H3 from '../../typography/H3';

type ErrorProps = StyledSystemProps;

const ErrorCont = styled.div<ErrorProps>`
  ${space};
  display: flex;
  border-radius: 4px;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  border: 1px solid ${themeGet('colors.primary', '#000')};
`;

const Error: React.FC<ErrorProps> = () => {
  return (
    <ErrorCont m={4} p={4}>
      <AlertTriangle size={80} color={theme.colors.primary} />
      <H3>Sorry, something went wrong.</H3>
    </ErrorCont>
  );
};

export default Error;
